import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

import background from '../Assets/template/background.jpg';
import hibale from '../Assets/template/hibale.jpg';
import carcar from '../Assets/template/carcar.jpg';
import bohol from '../Assets/template/bohol.jpg';
import story1 from '../Assets/template/story1.jpg';
import story2 from '../Assets/template/story2.jpg';
import story3 from '../Assets/template/story3.jpg';
import story4 from '../Assets/template/story4.jpg';
import story5 from '../Assets/template/story5.jpg';

const quotes = [
  "WE ARE VERY HAPPY AND THANKFUL TO NIA BECAUSE WE FARMERS HAVE BEEN GIVEN IRRIGATION. BECAUSE IF THERE'S NO IRRIGATION, OUR FARMING MUST HAVE BEEN TOUGH AND HARD. – BELINDA DACLAN",
  "I NEVER IMAGINED THAT THIS PROJECT CAN GIVE US CONSTANT SUPPLY OF WATER. LET US BE THANKFUL... – MODESTO TAMPUS",
  "THE WATER PIPE IS INSTALLED WITHIN THE VICINITY OF OUR GARDEN... THAT'S THE BIG DIFFERENCE THE PROJECT HAS BROUGHT US. – VICTORIA GEDORIO",
];

const scrollingImages = [story1, story2, story3, story4, story5];

const SuccessStories = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % quotes.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <BackgroundWrapper>
      <PageContainer>
        <HeaderSection>
          <Title>Success Stories That Shaped Generations</Title>
          <SubTitle>A Legacy of Growth, Water, and Nation-Building</SubTitle>
        </HeaderSection>

        <TopSection>
          <LeftPanel>
  <QuoteCarousel>
    {quotes.map((quote, index) => {
      let position = 'hidden';
      if (index === currentIndex) position = 'center';
      else if (index === (currentIndex - 1 + quotes.length) % quotes.length) position = 'left';
      else if (index === (currentIndex + 1) % quotes.length) position = 'right';

      return (
        <QuoteCard key={index} position={position}>
          {quote}
        </QuoteCard>
      );
    })}
  </QuoteCarousel>
</LeftPanel>

          <RightPanel>
            <VerticalBox>
              <ImageBox>
                <img src={hibale} alt="Hibale" />
                <TextBox>HIBALE GROUNDBREAKING</TextBox>
              </ImageBox>
              <ImageBox>
                <img src={carcar} alt="Carcar" />
                <TextBox>CARCAR CITY CEBU TESTIMONY</TextBox>
              </ImageBox>
              <ImageBox>
                <img src={bohol} alt="Bohol" />
                <TextBox>BOHOL FARMER SUCCESS</TextBox>
              </ImageBox>
            </VerticalBox>
          </RightPanel>
        </TopSection>

        <BottomScroller>
          <ScrollTrack>
            {[...scrollingImages, ...scrollingImages].map((img, i) => (
              <ScrollerImage key={i} src={img} alt={`Story ${i + 1}`} />
            ))}
          </ScrollTrack>
        </BottomScroller>
      </PageContainer>
    </BackgroundWrapper>
  );
};

export default SuccessStories;

// === STYLED COMPONENTS ===

const BackgroundWrapper = styled.div`
  background: url(${background}) no-repeat center center;
  background-size: cover;
  min-height: 80vh;
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 91vh;
  position: relative; /* 🧭 Required for absolutely positioned children */
`;


const HeaderSection = styled.div`
  text-align: left;
  padding: 20px;
`;

const Title = styled.h1`
  font-size: 42px;
  font-weight: bold;
  color: white;
  margin: 0;
`;

const SubTitle = styled.h2`
  font-size: 28px;
  font-style: italic;
  color: #d9f4dd;
  font-weight: 400;
  margin: 0;
`;

const TopSection = styled.div`
  display: flex;
  flex: 1;
  gap: 20px;
  padding: 20px;
`;

const LeftPanel = styled.div`
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 350px;
  overflow: hidden;
  position: relative;
`;

const QuoteSlider = styled.div`
  display: flex;
  transition: transform 0.6s ease;
  transform: translateX(${(props) => `calc(50% - ${props.index * 360}px)`});
  gap: 30px;
`;

const QuoteCarousel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  height: 220px;
`;

const QuoteCard = styled.div`
  position: absolute;
  width: ${(props) => (props.position === 'center' ? '520px' : '400px')};
  height: ${(props) => (props.position === 'center' ? '300px' : '260px')};
  opacity: ${(props) => (props.position === 'center' ? 1 : 0.4)};
  transform: ${(props) =>
    props.position === 'center'
      ? 'translateX(0) scale(1.1)'
      : props.position === 'left'
      ? 'translateX(-460px) scale(0.92)'
      : props.position === 'right'
      ? 'translateX(460px) scale(0.92)'
      : 'scale(0)'};
  transition: all 0.6s ease;
  background: white;
  border-radius: 16px;
  padding: 30px;
  font-size: 16px;
  font-weight: normal;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.6;
`;

const RightPanel = styled.div`
  width: 350px;
  position: absolute;   /* 🔧 Takes it out of flow */
  top: 0;
  right: 0;
  height: 91vh;        /* 🧱 Full screen height */
`;

const VerticalBox = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: white;
  padding: 10px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  z-index: 2;
  position: relative;
`;

const ImageBox = styled.div`
  position: relative;
  border-radius: 0px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  flex: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const TextBox = styled.div`
  position: absolute;
  bottom: 0;
  background-color: rgba(0, 80, 0, 0.8);
  color: white;
  width: 100%;
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

const scrollAnim = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const BottomScroller = styled.div`
  overflow: hidden;
  width: 100%;
  height: 120px;
  background-color: rgba(255,255,255,0.85);
`;

const ScrollTrack = styled.div`
  display: flex;
  animation: ${scrollAnim} 30s linear infinite;
`;

const ScrollerImage = styled.img`
  height: 120px;
  width: auto;
  object-fit: cover;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  display: block;
`;
